var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AchooInputComponent } from '../achoo-input/achoo-input.component';
import { ValidationHandlerService } from '../validation-handler.service';
var AchooTextFieldComponent = /** @class */ (function (_super) {
    __extends(AchooTextFieldComponent, _super);
    function AchooTextFieldComponent(validationHandlerService) {
        var _this = _super.call(this, validationHandlerService) || this;
        _this.validationHandlerService = validationHandlerService;
        _this.isTelephoneField = false;
        _this.isPasswordField = false;
        _this.showError = true;
        return _this;
    }
    return AchooTextFieldComponent;
}(AchooInputComponent));
export { AchooTextFieldComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-text-field/achoo-text-field.component.ts.pre-build-optimizer.js